import { TFunction } from 'react-i18next'
import { zonesService } from '../../../../service/zones'
import { ResponseZones } from '../../../../service/zones/response'
import { httpFetch } from '../../../../utils/crud'
import { RequestErrors, Types } from '../../../../utils/enums'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { Color } from '../../../../utils/theme/types/color'
import { ObjectGeneric } from '../../../../utils/types/generals'
import { isRequired, searchInModeLower } from '../../../../utils/validate/validate'
import { format, getYear } from 'date-fns'
import { Constants } from '../../../../utils/constants'
import { es } from 'date-fns/locale'

export const getList = async (colors: Color, t: TFunction<'translation', undefined>,query?:string) => {
  const data = await zonesService(httpFetch).getAllZonesWithFilter(query)

  const totalPages = !data.errors ? data.totalPages : 0;

  const fatherIds: number[] = []
  const row = !data?.errors
    ? data?.items.map((item) => {
        fatherIds.push(item?.id)
        return {
          id: item?.id,
          description: item.description,
          name: item.name,
          //zoneInitId: item.zoneInitId,
          //zoneFather: item.zoneParent,
          createTime: format(new Date(item.createTime), Constants.dateFormatGeneral),
        }
      })
    : []

  return { row, totalPages } as {
    row: {
      id: number | null
      name: string | null
      description: string | null
      createTime: string | null
      //zoneInitId: number | null
    }[]
    totalPages: number
  }
}

export const filterRow = (value: { [x: string]: any }, list: any[]) => {
  const from = value.from?.valueOf()
  const to = value.to?.valueOf()
  return list?.filter((item) => {
    return (
      (from ? new Date(from).setHours(0, 0, 0, 0) <= Date.parse(item?.create_time) : true) &&
      (to ? new Date(to).setHours(23, 59, 59, 999) >= Date.parse(item?.create_time) : true) &&
      (value?.month instanceof Array ? (value?.month.length > 0 ? value?.month.find((e: any) => e.value === item.monthNumber) : true) : true) &&
      (value?.createYear instanceof Array ? (value?.createYear.length > 0 ? value?.createYear.find((e: any) => e.value === item.createYear) : true) : true) &&
      ((value?.search ? searchInModeLower(item?.id, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.description, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.name, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.zoneInitId, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.createYear, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.month, value?.search) : true))
    )
  })
}

export const handleErrors = (values: any, t: any, ignore?: string[]) => {
  let error = {} as ObjectGeneric
  if (values?.description !== null) {
    if (isRequired(values?.description)) error.description = t('general.validations.required')
  }
  if (values?.name !== null) {
    if (isRequired(values?.name)) error.name = t('general.validations.required')
  }

  return error
}

export const submit = async (data: ObjectGeneric, t: TFunction<'translation', undefined>, id: number | undefined) => {
  let snackbarBody = {
    open: false,
    type:  Types.SUCCESS,
    message: '',
  }
  let body = {} as any
  Object.entries(data).forEach(([key, value]) => {
    const dataToSubmit = ['name', 'description', 'zoneInitId']
    if (dataToSubmit.includes(key)) {
      body = {
        ...body,
        [key]: value ?? null,
      }
    }
  })

  let response: ResponseZones

  if (id) {
    response = await zonesService(httpFetch).updateZones(body, id)
  } else {
    response = await zonesService(httpFetch).createZones(body)
  }

  if (response.errors) {
    snackbarBody = {
      open: true,
      type: Types.ERROR,
      message: handleAllErrors(response?.errors?.[0]?.code as RequestErrors, t, `zones.snackbar.${id ? 'update' : 'create'}.error`),
    }
  } else {
    snackbarBody = {
      open: true,
      type: Types.SUCCESS,
      message: t(`zones.snackbar.${id ? 'update' : 'create'}.success`),
    }
  }

  return {
    snackbarBody,
    response,
  }
}